import Image from 'next/image'

// Wrapper around next/image that keeps the props of the former next/legacy/image
// version (layout, objectFit, light, placeholder), so call sites stay unchanged:
//   layout='fill'        -> fills its positioned parent
//   layout='responsive'  -> full width of its parent, height from the ratio
//   default (intrinsic)  -> its own size, shrinking to fit narrow parents
// While loading, the image shows a flat background colour instead of the
// former base64 shimmer SVG (which added ~850 bytes of HTML per image).
const ImageLoader = ({
  layout,
  objectFit,
  objectPosition,
  light,
  placeholder,
  style,
  onLoad,
  ...props
}) => {
  // The loading colour must not stay behind transparent images (flags, icons, PNGs)
  const handleLoad = (event) => {
    event.currentTarget.style.backgroundColor = 'transparent'
    onLoad?.(event)
  }

  const background = placeholder === false ? undefined : (light ? '#352e44' : '#efedf0')

  const layoutStyle =
    layout === 'fill' ? {} :
    layout === 'responsive' ? { width: '100%', height: 'auto' } :
    layout === 'fixed' ? {} :
    { maxWidth: '100%', height: 'auto' }

  return (
    <Image
      {...props}
      onLoad={handleLoad}
      fill={layout === 'fill' || undefined}
      style={{
        ...layoutStyle,
        ...(objectFit && { objectFit }),
        ...(objectPosition && { objectPosition }),
        ...(background && { backgroundColor: background }),
        ...style,
      }}
    />
  )
}

export default ImageLoader
